import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { Icon } from '@fiverr-private/fit';
import {
    r_facebook,
    r_linkedin,
    r_twitter,
    r_behance,
    r_dribbble,
    r_github,
    r_google_monochrome,
    r_stack_overflow,
    r_vimeo
} from '@fiverr-private/icons/social';
import { grey_1000 } from '@fiverr-private/sass/helpers';
import './style.scss';

const NETWORK_ICONS = {
    'facebook': r_facebook,
    'linkedin': r_linkedin,
    'twitter': r_twitter,
    'google': r_google_monochrome,
    'stack-exchange': r_stack_overflow,
    'dribbble': r_dribbble,
    'behance': r_behance,
    'vimeo': r_vimeo,
    'github': r_github
};

export default function SocialAccount({ platformData }) {
    const { platform } = platformData;
    const platformNameText = capitalize(platform.replace('_', ' '));
    const icon = NETWORK_ICONS[platform.replace('_', '-')];
    const iconProps = {
        color: grey_1000,
        size: 14,
        className: 'social-icon'
    };

    return (
        <li className="social-account">
            <Icon {...iconProps}>{ icon }</Icon>
            <span className="text">{platformNameText}</span>
        </li>
    );
}

SocialAccount.propTypes = {
    platformData: PropTypes.shape({
        platform: PropTypes.string
    })
};

SocialAccount.defaultProps = {
    platformData: {
        platform: ''
    }
};
